import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import useVideos, { VideoEvent } from "./useVideos";
import Widget from "../Widget";

const VideoWidgetEmbed = (props: { userId: string; widgetId: string }) => {
  const {
    identifier,
    video,
    visible,
    willDisappear,
    showVideo,
    hideVideo,
    playVideo,
  } = useVideos();

  useTopic(`widget:${props.widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "video:show":
        showVideo(message.payload as VideoEvent);
        break;
      case "video:skip":
        hideVideo(0);
        break;
    }
  });

  useTopic(`user:widgets:video:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "video:skip":
        hideVideo(0);
        break;
    }
  });

  if (video) {
    return (
      <Widget
        key={identifier}
        visible={visible}
        willDisappear={willDisappear}
        onReady={() => playVideo()}
        onEnded={() => hideVideo(0)}
        {...video}
      />
    );
  }

  return null;
};

export default VideoWidgetEmbed;
